import { useMemo } from 'react'
import { useGetAreas } from '../api/useGetAreas'
import { useAreaStore } from '../store'

export const useGetAreasRoutes = () => {
    const { selectedAreaCode } = useAreaStore()
    const { data: areas = [] } = useGetAreas()

    const areaRoutes = useMemo(() => {
        if (selectedAreaCode === 'all') {
            return areas?.flatMap((area) => area.workstations.flatMap((ws) => ws.routes)) || []
        }

        if (selectedAreaCode !== 'night') {
            const area = areas.find((item) => item.code === selectedAreaCode)

            return area?.workstations.flatMap((item) => item.routes) || []
        }

        const nightWorkstations = areas
            .filter((area) => ({ ...area, workstations: area.workstations.filter((ws) => ws.isNightNetwork) }))
            .filter((area) => area.workstations.length)
            .flatMap((area) => area.workstations)

        return nightWorkstations.flatMap((item) => item.routes).filter((route) => route.dayType === 'Night')
    }, [selectedAreaCode, areas])

    return { areaRoutes }
}
